<template>
  <SimpleDataCard
      :title="'Toplam Bekleyen Sipariş'"
      :data="numberConverter(reportCompanyData.totalPendingOrderAmount,'TRY')"
      :description="'Tüm Zamanlar'"
      :loading="reportCompanyDataLoading"
      route="pending-order-list"
  >

  </SimpleDataCard>
</template>

<script>

import SimpleDataCard from "@/components/dashboard/SimpleDataCard.vue";
import {numberConverter} from "../../../../helpers";
import {mapState} from "vuex";

export default {
  name: "ToplamBekleyenSiparisTutari",
  components:{
    SimpleDataCard
  },
  computed: {
    ...mapState("dashboard",["reportCompanyData","reportCompanyDataLoading"])
  },
  methods:{
    numberConverter
  }
}
</script>

<style scoped>

</style>